<template>
  <div :class="$style.container">
    <div :class="$style.containerHeader">
      <slot name="header"/>
    </div>
    <div :class="containerStyles">
      <slot />
    </div>
    <div :class="$style.containerFooter">
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Mobile container.
 * Wrapper for create pages.
 */
@Component({
  props: {
    flexContent: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class MobileContainer extends Vue {
  get containerStyles() {
    return [
      this.$style.containerContent,
      { [this.$style.flexContent]: this.flexContent },
    ];
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: $mobile-bg-color;

  &Header {
    width: 100%;
    position: relative;
    z-index: 10;
    &:empty {
      display: none;
    }
  }

  &Content {
    flex: auto;
    height: 100%;
    overflow: auto;

    &.flexContent {
      height: calc(var(--layout-height) - #{$mobile-header-min-height});
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }
  }

  &Footer {
    width: 100%;
    position: relative;
    z-index: 10;
    &:empty {
      display: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileContainer.vue